import { Dto } from '@core/data/dto/dto';
import { DTO_DEFAULT, DtoType } from '@core/data/dto/dto-types';
import { Entity } from '@core/data/dto/entity';
import { DtoExport, DtoImport } from '@core/utils/dto';
import { copyObjectProperties } from '@core/utils/object';
import { TipSourceConfigSchema } from './tip-source-config.schema';
import { TipSourceTipType } from './tip-source-tip-type';

export class TipSourceConfig implements Entity {
    public tipTypes: TipSourceTipType[];

    constructor(value?: any) {
        if (value) {
            copyObjectProperties.call(this, value);
        }
    }

    @DtoImport(TipSourceConfigSchema)
    static import(dto: Dto): any {
        return new TipSourceConfig(dto);
    }

    @DtoExport([
        {
            type: DTO_DEFAULT,
            dto: TipSourceConfigSchema,
        },
    ])
    export(type?: DtoType): any {}
}
